import { render, staticRenderFns } from "./RoleCard.vue?vue&type=template&id=ba7cd328&"
import script from "./RoleCard.vue?vue&type=script&lang=js&"
export * from "./RoleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports